import React from 'react'
import PropTypes from 'prop-types'
import { IconButton, Typography } from '@material-ui/core'
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace'
import { useHistory } from 'react-router-dom'

import clientHeaderStyles from './css/clientHeaderStyles'

const ClientHeader = ({ title, subTitle, step, totalSteps }) => {
  const classes = clientHeaderStyles()
  const history = useHistory()

  return (
    <div className={classes.root}>
      <IconButton
        className={classes.iconButton}
        onClick={() => {
          history.goBack()
        }}
      >
        <KeyboardBackspaceIcon className={classes.icon} />
      </IconButton>
      <div className={classes.headerContainer}>
        <Typography gutterBottom className={classes.steps}>
          Paso {step} de {totalSteps}
        </Typography>
        <Typography color="inherit" align="left" variant="h5" className={classes.title}>
          {title}
        </Typography>
        <Typography color="inherit" align="left" variant="subtitle1" className={classes.subTitle}>
          {subTitle}
        </Typography>
      </div>
    </div>
  )
}

ClientHeader.propTypes = {
  title: PropTypes.string,
  subTitle: PropTypes.string,
  step: PropTypes.string,
  totalSteps: PropTypes.string,
}

ClientHeader.defaultProps = {
  title: '',
  subTitle: '',
  step: '',
  totalSteps: '',
}

export default ClientHeader
